const getInitialState = () => ({
    openRequests: [],
    failedRequests: [],
    updatedAt: 0,
    resultRatings: {
        entries: {},
        maxCount: 0,
    },
    lastInteractiveGuid: null,
});

export default {
    getInitialState
};
